module.exports = __webpack_public_path__ + "img/star-full.c2f18c92.svg";